import { IProduct } from "@bca-shared/models/product";
import { IRootState } from "@bca-store/store.reducers";
import { createSelector } from "@ngrx/store";
import { IState } from "./compose.reducer";

export const selectFeature = (state: IRootState) => state.compose;

export const selectProducts = createSelector(
  selectFeature,
  (state: IState) => state.products,
);

export const selectProductByIdentifier = (identifier: string) =>
  createSelector(selectProducts, (products: IProduct[]) => {
    return products
      ? products.find((product) => product.identifier === identifier)
      : undefined;
  });
